export default __webpack_public_path__ + "ca61cf8bac41f4079f9bb71e47702b09.png";